import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { fetchLeaderboard } from "../../features/store/userSlice";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { leaderboardData } from "../../data/DemoData";
import { RootState } from "../../redux/store";

const Leaderboard = () => {
  const [toggle, setToggle] = useState<string>("monthly");
  const dispatch = useAppDispatch();
  const { leaderboard, loading } = useAppSelector(
    (state: RootState) => state.users,
  );

  useEffect(() => {
    dispatch(fetchLeaderboard(toggle));
  }, [toggle, dispatch]);

  return (
    <div
      className="col-4 p-4 rounded-lg min-w-[288px]"
      style={{
        backgroundImage: `url(/images/bg.png)`,
        // backgroundPosition: "center top", // Focus on the top-center part of the image
        // backgroundSize: "400% 300%", // Stretch the image height to 200% so the top 50% is visible
        backgroundRepeat: "no-repeat",
      }}
    >
      <Header toggle={toggle} setToggle={setToggle} />
      <Body data={leaderboard || []} loading={loading} type={toggle} />
    </div>
  );
};

export default Leaderboard;

const Header = ({
  toggle,
  setToggle,
}: {
  toggle: string;
  setToggle: (val: string) => void;
}) => {
  const { t } = useTranslation();
  const translate = t as unknown as (key: string) => string;

  return (
    <div className="col-4">
      <div className="col-2 place-items-center">
        <img src="/png/crown.png" alt="" className="size-10" />
        <span className="lt-xl-semibold-main-dark">
          {translate("main.leaderboard")}
        </span>
      </div>
      <div className="rounded-2xl p-[6px] row-2 bg-BG-light dark:bg-BG-dark">
        {["monthly", "allTime"].map((item, index) => (
          <button
            key={index}
            className={`flex-1 py-[6px] px-[10px] place-content-center ${
              toggle === item
                ? "inter-xs-semibold-white rounded-2xl bg-toggleBG-light"
                : "inter-xs-medium-toggleBG-dark dark:text-main-dark"
            }`}
            onClick={() => setToggle(item)}
          >
            {translate(`main.${item}`)}
          </button>
        ))}
      </div>
    </div>
  );
};

const Body = ({
  data,
  loading,
  type,
}: {
  data: any[];
  loading: boolean;
  type: string;
}) => {
  leaderboardData.sort((a, b) => b.point - a.point);
  const { t } = useTranslation();
  const translate = t as unknown as (key: string) => string;
  return (
    <div className="col-2">
      {data.map((user, index) => (
        <div className="row-2 rounded-lg px-4 py-2 bg-BG-light dark:bg-BG-dark">
          <div className="row-2 items-center">
            <Position index={index} />
            <img
              className="size-11"
              src={user.image_url || "/png/IVCartoon.png"}
              alt={user.username}
            />
          </div>
          <div className="flex flex-col justify-center">
            <span className="inter-xs-bold-black dark:text-main-dark">
              {/* {leaderboard.title} */}
              {user.username || `${user.firstname}`}
            </span>
            <span className="inter-xs-bold-pry-600 text-[10px]">
              {type === "monthly"
                ? user.monthly_accumulated_points
                : user.alltime_accumulated_points}{" "}
              {translate("main.points")}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

const Position = ({ index }: { index: number }) => {
  const commonClassses =
    "size-6 flex items-center justify-center rounded-full p-2";
  if (index < 3) {
    const lbColor = ["#FFBF00", "#C0C0C0", "#CD7F32"];
    const bgColor = lbColor[index];
    return (
      <span
        className={`${commonClassses} satoshi-sm-bold-white`}
        style={{ backgroundColor: bgColor }}
      >
        {index + 1}
      </span>
    );
  } else {
    return (
      <span
        className={`${commonClassses} satoshi-sm-bold-toggleBG-dark dark:text-white border border-border-light dark:border-x-border-dark`}
      >
        {index + 1}
      </span>
    );
  }
};
